export default {
    FPDualEntryComputer: {
        datapoint: {
            name: 'FPDualEntryComputer',
            customData: function (entrySource) { return ({ entrySource: entrySource }); },
        },
    },
    FPDualEntryFilePicker: {
        datapoint: {
            name: 'FPDualEntryFilePicker',
            customData: function (entrySource) { return ({ entrySource: entrySource }); },
        },
    },
    ComposeDropHint: {
        datapoint: {
            name: 'ComposeDropHint',
            customData: function (dataTransferType) { return [dataTransferType]; },
        },
    },
    ComposeCommandInsertSignature: {
        datapoint: {
            name: 'ComposeCommandInsertSignature',
        },
    },
    EditorTypingPerf: {
        datapoint: {
            name: 'EditorTypingPerf',
        },
    },
};
//# sourceMappingURL=datapoints.js.map